import React from 'react';
import {
	Stepper,
	Step,
	StepLabel,
	Button,
	Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Result } from 'antd';

const StepperComp = ({
	activeStep,
	steps,
	classes,
	getStepContent,
	handleBack,
	handleNext,
	handleSubmitApplication,
	handleReset,
	householdDisability,
	workCertificate,
	profession,
	homeAddress,
	salarynet,
	employmentType,
	employerName,
	maritalStatusCertificate,
	spousePhone,
	maritalStatus,
	spouseHomeAddress,
	spouseEmployerName,
	spouseSalarynet,
	spouseEmploymentType,
	spouseWorkCertificate,
	houseRangeId,
	meetDownCapacity,
	insured,
	houseCategoryId1,
	district1,
	bankProviderId1,
	spouseProfession,
	application,
	open,
	handleClose,
}) => {
	const { t } = useTranslation();
	return (
		<div>
			<Stepper activeStep={activeStep} style={{backgroundColor: "#fafafa"}} >
				{steps.map((label, index) => {
					const stepProps = {};
					const labelProps = {};
					return (
						<Step key={label} {...stepProps}>
							<StepLabel
								{...labelProps}
								classes={{
									label: classes.customLabelStyle,
									iconContainer: classes.iconContainer,
								}}
							>
								{label}
							</StepLabel>
						</Step>
					);
				})}
			</Stepper>
			<div>
				{application.status === 201 ? (
					<>
          <Result
          subTitle={t('step-completed')}
          status="success"
          
          />
            <div className="d-flex justify-content-center">
						<Button
							onClick={handleReset}
							className={"custom-btn"}
							variant='contained'
							color='primary'
						>
							{t('my-application')}
						</Button></div>
					</>
				) : (
					<div>
						<Typography className={classes.instructions} component='div'>
							{getStepContent(activeStep)}
						</Typography>
						<div>
							<Button
								disabled={activeStep === 0}
								onClick={handleBack}
								// className={classes.button}
								variant='outlined'
								className={classes.backButton}
							>
								{t('back')}
							</Button>
							<Button
								variant='contained'
								onClick={
									activeStep === steps.length - 1
										? handleSubmitApplication
										: handleNext
								}
								className={classes.nextButton}
							>
								{activeStep === steps.length - 1 && application.loading
									? `${t('Submitting')}`
									: activeStep === steps.length - 1
									? `${t('apply')}`
									: `${t('next')}`}
							</Button>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default StepperComp;
